import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	type PinnedItem,
	PinnedItems,
} from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/PinnedItems";
import type { PinKind } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/pinKind";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	kind: PinKind;
	open: boolean;
	onClose: () => void;
	pinnedItems: PinnedItem[];
	isPending: boolean;
	footnote?: string;
	onUnpin: (id: number) => void;
	children: ReactNode;
};

export const PinChoiceDrawer: FC<Props> = ({
	kind,
	open,
	onClose,
	pinnedItems,
	isPending,
	footnote,
	onUnpin,
	children,
}) => {
	const { palette, spacingTokens } = useTheme();
	const { t } = useResource();
	const kindResources = Resources.PortfolioDetail.Pin.Kind[kind];

	return (
		<MyPlannDrawer
			anchor="bottom"
			grabber
			open={open}
			onClose={onClose}
			title={t(kindResources.chooseTitle)}
		>
			<Stack pb={spacingTokens.xl}>
				<Typography
					variant="caption"
					color={palette.grey[500]}
					px={spacingTokens.lg}
					pb={1.4}
					display="block"
				>
					{t(kindResources.chooseIntro)}
				</Typography>
				<PinnedItems
					items={pinnedItems}
					isPending={isPending}
					footnote={footnote}
					onUnpin={onUnpin}
				/>
				{children}
			</Stack>
		</MyPlannDrawer>
	);
};
